// extracted by mini-css-extract-plugin
export default {"container":"ExpenseTracker_container__VdTlI"};